import PromotionEntry from './includes/pages/roleTokens/PromotionEntry';
import GroupInvitationPublic from './includes/pages/groupInvitations/GroupInvitationPublic';
import GroupInvitationJoin from './includes/pages/groupInvitations/GroupInvitationJoin';
import GroupInvitationsAdmin from './includes/pages/groupInvitations/GroupInvitationsAdmin';
import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import {BrowserRouter, Routes, Route, Navigate, useLocation} from "react-router-dom";
import logoElakay from './includes/Layout/icon/logoelakayDiamant-656.png';
import elakay_logo_loading from "./includes/Layout/imgs/elakay_loading3.gif";
import imageEmptyelakay from "./includes/Layout/imgs/imageEmptyelakay.jpeg";
import { FirtIDCategory } from "./config"; 
// permission pages
import { signout, readMe, isAuthenticated, getElakayLang, SetElakayLang,  getCart, getPersistedSelectedRole, clearPersistedSelectedRole} from "./includes/auth";
import { setSelectedRoleOverride, Family } from "./includes/pageInside/Rolle";
import { getCategoriesByID } from "./includes/auth/apiCategory";
import { getTrashProducts } from "./includes/auth/apiProduct";
import { getEmailInboxUnreadCountAPI } from "./includes/auth/apiEmailInbox";
import UserSignin from "./includes/auth/userSignin"
import EventStepAuthGate from "./includes/pages/roleTokens/EventStepAuthGate"
// import UserElakay from "./includes/auth/userCustomer"
import UserSeller from "./includes/auth/userSeller"
import UserProvider from "./includes/auth/userProvider"
import UserAssoociate from "./includes/auth/userAssoociate"
import UserAdmin from "./includes/auth/userAdmin"
import UserFamily from "./includes/auth/userFamily"
import PageAccessRoute from "./includes/auth/PageAccessRoute"
import SwiperAccessRoute from "./includes/auth/userSwiperAccess"
import Loader1 from './includes/Layout/imgs/loading3.gif';
import {laguangeElakay, language, setElakayLanguageContext} from "./includes/pageInside/dataElakay";
import menuElakay from "./language/menuElakay_en.json";
import {loadMenuLanguage} from "./language/loadMenuLanguage";
import { effectiveLanguageSection } from "./language/mergeLanguageSources";
import {LanguageElakayByLanguage} from "./includes/auth/apiLanguage"
import {allDeviceUserArgent} from "./includes/auth/checkDevice"
import {getFirstAnimationSettingsAPI} from "./includes/auth/Animationsettingsapi"
import {requestCurrentPosition} from "./utils/geolocation";
import {applyDefaultTitleStyleVars} from "./utils/titleStyle";
import {applyAppPwaSettings, DEFAULT_APP_PWA} from "./utils/appPwa";
import {useElakayDocumentTitle} from "./includes/Layout/Layout";
// import Page_APP  from "./includes/pageInside/exeemple_page/App";
// import ProjectEditorExample from "./includes/Elakay_investement/ProjectEditorExample";
import animationConfigData from './animationConfig.json';

//  ---------- user ---------

import Signup from "./user/Signup";
import { NavigationHistoryTracker } from "./includes/auth/navigationHistory";
import Signin from "./user/Signin";
import Active from "./user/active";
import ForgetPassword from "./user/forgetPassword";
import Password from "./user/password"


// ----------------Page for All User---------------------- 
import Home from "./includes/pages/home";
import Step from "./includes/pages/userStep"
import ProductPreview from "./includes/pages/productPreview";
import PublicMarketingPage from "./includes/pages/PublicMarketingPage";
import ShopUser from "./includes/pages/ShopUser";
import ShopAboutPage from "./includes/pages/lakayUser/ShopAboutPage";
import ErrorPage from "./includes/pages/errorPage";
import NewProduct from "./includes/pages/newProduct";
import BestSellers from "./includes/pages/bestSellers";
import ProductCatalog from "./includes/pages/productCatalog";
import Search from "./includes/pages/resultsSearch";
import AllCategories from "./includes/pages/allCategories"
import HelpContart from "./includes/pages/helpContact"
import DealToday from "./includes/pages/dealtoday"
import UserView from "./includes/pages/userViewed"
import SearchHistoryAllCards from "./includes/pages/searchHistoryAllCards"
import ViewingActivityAllCards from "./includes/pages/viewingActivityAllCards"
import ShopsYouFollowAllCards from "./includes/pages/shopsYouFollowAllCards"
import Investments from "./includes/pages/investments";
import InvestmentDetail from "./includes/pages/investmentDetail";
import Jobs from "./includes/pages/jobs";
import JobDetail from "./includes/pages/jobDetail";
import MyJobApplications from "./includes/pages/myJobApplications";
import HowWeDoIt from "./includes/pages/howWeDoIt";
import HowWeDoItDetail from "./includes/pages/howWeDoItDetail";


//----------------Page for All User + top---------------------- 
import Cart from "./includes/pages/Cart";
import UserProduct from "./includes/pages/userProduct"
import EditProduct from "./includes/pages/editProduct/editProduct"
import Wallet from "./includes/pages/wallet"
import HowToStep from "./includes/pages/howToStep"; 

import UserSerting from "./includes/pages/userSerting"
import Account from "./includes/pages/userAccount" 
import AccountSettings from "./includes/pages/AccountSettings"
import Profile from "./includes/pages/userProfile"  

import Orders from "./includes/pages/Orders"
import Delivery from "./includes/pages/Delivery"
import Postman from "./includes/pages/Postman"
import Purchased from "./includes/pages/userPurchased"
import Message from "./includes/pages/userMessage"
import ContactRequestsInbox from "./includes/pages/contactRequestsInbox"

import Admin_associate from "./includes/pages/admin_associate"
import UserChoosingEntry from "./includes/pages/roleTokens/UserChoosingEntry";

//  -------- Category for admin & familly --------- 
import CreatCategory from "./includes/pages/addCategory"
import CreatFilters from "./includes/pages/addFilters"
import CreatFiltersValue from "./includes/pages/addFilterValues"
import CreatFilerCategory from "./includes/pages/addCategoryFilter"
import CreatfilterValue from "./includes/pages/addCategoryFilterValue"

import AdminFamily from "./includes/pages/addAdminFamily"

import PresenceBeacon from "./includes/Layout/PresenceBeacon";
import HeaderFooterThemeSync from "./includes/Layout/HeaderFooterThemeSync";
import EmailMarketingAccessRoute from "./includes/pageInside/EmailMarketing/EmailMarketingAccessRoute";
import EmailInboxPage from "./includes/pages/emailInboxPage";
import CJDropshippingDashboard from "./includes/pages/CJDropshippingDashboard";
// Dropshipping Interne Elakay -- système natif indépendant de CJDropshippingDashboard ci-dessus.
import {
  ProviderAddProduct,
  ProviderEditProduct,
  ProviderProducts,
  SellerProviderMarketplace,
  SellerProviderProducts,
  DropshippingIn,
  DropshippingInAddProduct,
  ProviderProductDetail,
  OrdersPage,
  InventoryPage,
  ProviderSettings,
  ConnectedSellers,
  ConnectedSellerProducts,
  ProviderTrash,
  ProviderPAPlans,
  ProviderSubscribers,
  SellerPASubscriptions,
  ProviderCatalog,
  ProviderCenter,
  ProviderMyShop,
  ProviderStorefrontBuilder,
  ProviderStorefrontPage,
  ProviderHistoryPage,
  ProviderProductHistoryPage,
} from "./includes/dropshippingInterne";
import { SellerMyShopRoute, SellerProductEditRoute } from "./includes/auth/sellerWorkspaceRoute";
import { ProviderStorefrontRoute } from "./includes/auth/providerStorefrontRoute";

import AddLanguage from "./includes/pages/AddLanguage";

import AddTraductorTeam from "./includes/pages/AddTraductorTeam";
import LinkCatToCat from "./includes/pages/LinkCatToCat";
import imgLakay1 from './includes/Layout/imgs/Elakay-account-1.png';
import imgLakay2 from './includes/Layout/imgs/Royalty-user-1.png';
import imgLakay3 from './includes/Layout/imgs/Seller-pub-1.png';
import {decryptData}  from './includes/auth/elakayCryptage'
import { elakayAutoText } from "./includes/pageInside/dataElakay";

// The three large authoring surfaces are route-only dependencies. Loading
// them on demand keeps the storefront/My Shop entry bundle from eagerly
// evaluating both editors and the complete Page Builder on every visit.
const PageBuilderIndex = lazy(() => import("./includes/pageInside/PageBuilder"));
const EmailMarketingDashboard = lazy(() => import("./includes/pages/emailMarketingDashboard"));
const EmailMarketingEditor = lazy(() => import("./includes/pages/emailMarketingEditor"));
const InvestmentDashboard = lazy(() => import("./includes/pages/investmentDashboard"));
const JobDashboard = lazy(() => import("./includes/pages/jobDashboard"));
const JobPositionsAdmin = lazy(() => import("./includes/pages/jobPositionsAdmin"));
const JobApplicationsAdmin = lazy(() => import("./includes/pages/jobApplicationsAdmin"));
const HowWeDoItDashboard = lazy(() => import("./includes/pages/howWeDoItDashboard"));
const HowWeDoItEditor = lazy(() => import("./includes/pages/howWeDoItEditor"));
const AnimationSettings = lazy(() => import("./includes/pages/AnimationSettings"));
const SystemHealthDashboard = lazy(() => import("./includes/pages/SystemHealthDashboard"));
const TransactionCenter = lazy(() => import("./includes/pages/TransactionCenter/TransactionCenter"));
const ManualRefundPage = lazy(() => import("./includes/pages/ManualRefundPage"));
const SecurityCenter = lazy(() => import("./includes/pages/SecurityCenter"));
const MonitoringSettings = lazy(() => import("./includes/pages/MonitoringSettings"));
const SwiperManager = lazy(() => import("./includes/pages/SwiperManager"));
const SwiperStudioPage = lazy(() => import("./includes/pages/SwiperStudioPage"));
const DefaultPromoEditorPage = lazy(() => import("./includes/pages/DefaultPromoEditorPage"));
const EmailMarketingSettings = lazy(() => import("./includes/pages/EmailMarketingSettings"));
const ChatbotDashboard = lazy(() => import("./includes/pages/chatbotDashboard"));
const PermissionCenterPage = lazy(() => import("./includes/pages/PermissionCenter/PermissionCenterPage"));
const DeferredRoute = ({ children }) => (
  <Suspense fallback={<div role="status" style={{ padding: 24, textAlign: "center" }}>{elakayAutoText("h_b04ba49f848624", "Loading...")}</div>}>
    {children}
  </Suspense>
);

const pub = {
    promoInfo:{ 
                "_id": "null",
                "prod_id": "null",
                "customer_id": "null",
    }, 
    success: false,   
    promoUrl: {
       "urlProdView": null,
       "pastProdView": null,
       "urlShop": null,
       "pastShop": null
            }, 
    get error() { return elakayAutoText("h_b45327f5af69cd", "Promo is not laoding."); }
        }

const normalizeRoutePathname = (pathname = "/") => pathname.replace(/\/+$/, "") || "/";

const elakayRouteTitleRules = [
  { titleElakay: "logo", pattern: /^\/image\/logoElakayIco\.ico$/ },
  { titleElakay: "signin", pattern: /^\/signin$/ },
  { titleElakay: "signup", pattern: /^\/signup$/ },
  { titleElakay: "active", pattern: /^\/active\/[^/]+$/ },
  { titleElakay: "forgetPassword", pattern: /^\/forget-password$/ },
  { titleElakay: "password", pattern: /^\/password\/[^/]+$/ },
  { titleElakay: "userPub", pattern: /^\/userPUB\/[^/]+$/ },
  { titleElakay: "home", pattern: /^\/$/ },
  { titleElakay: "productPreview", pattern: /^\/product\/preview\/[^/]+$/ },
  { titleElakay: "newProduct", pattern: /^\/new-product$/ },
  { titleElakay: "bestSellers", pattern: /^\/best-sellers$/ },
  { titleElakay: "productCatalog", pattern: /^\/product\/[^/]+$/ },
  { titleElakay: "search", pattern: /^\/search$/ },
  { titleElakay: "allCategories", pattern: /^\/all-catageories$/ },
  { titleElakay: "helpContact", pattern: /^\/help-contact$/ },
  { titleElakay: "dealToday", pattern: /^\/deal-today$/ },
  { titleElakay: "investments", pattern: /^\/investments$/ },
  { titleElakay: "investmentDetail", pattern: /^\/investments\/[^/]+$/ },
  { titleElakay: "jobs", pattern: /^\/jobs$/ },
  { titleElakay: "jobDetail", pattern: /^\/jobs\/[^/]+$/ },
  { titleElakay: "howWeDoIt", pattern: /^\/how-we-do-it$/ },
  { titleElakay: "howWeDoItDetail", pattern: /^\/how-we-do-it\/[^/]+$/ },
  { titleElakay: "howWeDoItDashboard", pattern: /^\/elakay\/how-we-do-it-dashboard$/ },
  { titleElakay: "howWeDoItEditor", pattern: /^\/elakay\/how-we-do-it-editor(?:\/[^/]+)?$/ },
  { titleElakay: "emailMarketingDashboard", pattern: /^\/elakay\/email-marketing-dashboard$/ },
  { titleElakay: "emailMarketingEditor", pattern: /^\/elakay\/email-marketing-editor(?:\/[^/]+)?$/ },
  { titleElakay: "emailInbox", pattern: /^\/email-inbox(?:\/[^/]+)?$/ },
  { titleElakay: "emailMarketingSettings", pattern: /^\/elakay\/Settings\/email-marketing$/ },
  { titleElakay: "howToStep", pattern: /^\/how-to-Step$/ },
  { titleElakay: "shopAbout", pattern: /^\/lakay-ShopSeller\/[^/]+\/about$/ },
  { titleElakay: "shopSeller", pattern: /^\/lakay-ShopSeller\/[^/]+$/ },
  { titleElakay: "yourStep", pattern: /^\/your-step$/ },
  { titleElakay: "yourStep", pattern: /^\/user-step$/ },
  { titleElakay: "cart", pattern: /^\/cart$/ },
  { titleElakay: "userViewed", pattern: /^\/user-viewed$/ },
  { titleElakay: "searchHistoryAllCards", pattern: /^\/search-history$/ },
  { titleElakay: "viewingActivityAllCards", pattern: /^\/viewing-activity$/ },
  { titleElakay: "shopsYouFollowAllCards", pattern: /^\/shops-you-follow$/ },
  { titleElakay: "profile", pattern: /^\/profile$/ },
  { titleElakay: "orders", pattern: /^\/c\/orders$/ },
  { titleElakay: "account", pattern: /^\/account$/ },
  { titleElakay: "purchased", pattern: /^\/purchased$/ },
  { titleElakay: "message", pattern: /^\/message$/ },
  { titleElakay: "myJobApplications", pattern: /^\/my-job-applications$/ },
  { titleElakay: "wallet", pattern: /^\/wallet$/ },
  { titleElakay: "userSetting", pattern: /^\/user-setting$/ },
  { titleElakay: "myShop", pattern: /^\/myShop$/ },
  { titleElakay: "editProduct", pattern: /^\/product\/edit\/[^/]+$/ },
  { titleElakay: "delivery", pattern: /^\/delivery$/ },
  { titleElakay: "postman", pattern: /^\/postman$/ },
  { titleElakay: "userChoosing", pattern: /^\/user_Shoosing\/[^/]+$/ },
  { titleElakay: "addUsers", pattern: /^\/Add-u-all$/ },
  { titleElakay: "adminAssociate", pattern: /^\/admin_associat$/ },
  { titleElakay: "languageAdmin", pattern: /^\/elakay-language$/ },
  { titleElakay: "pageBuilder", pattern: /^\/pageBuilder$/ },
  { titleElakay: "investmentDashboard", pattern: /^\/elakay\/investments-dashboard$/ },
  { titleElakay: "jobDashboard", pattern: /^\/elakay\/job-dashboard$/ },
  { titleElakay: "jobPositions", pattern: /^\/elakay\/job-positions$/ },
  { titleElakay: "jobApplications", pattern: /^\/elakay\/job-applications$/ },
  { titleElakay: "animationSettings", pattern: /^\/elakay\/Settings$/ },
  { titleElakay: "swiperManager", pattern: /^\/elakay\/swipers(?:\/studio|\/default-promo)?$/ },
  { titleElakay: "chatbotDashboard", pattern: /^\/elakay\/chatbot-dashboard$/ },
  { titleElakay: "dropshipping", pattern: /^\/dropshipping(?:\/.*)?$/ },
  { titleElakay: "contactRequests", pattern: /^\/contact-requests$/ },
  { titleElakay: "traductorTeam", pattern: /^\/traductor-team$/ },
  { titleElakay: "category", pattern: /^\/category$/ },
  { titleElakay: "filterItems", pattern: /^\/filters\/items\/[^/]+$/ },
  { titleElakay: "filters", pattern: /^\/filters$/ },
  { titleElakay: "categoryFilters", pattern: /^\/filter\/[^/]+$/ },
  { titleElakay: "linkCategory", pattern: /^\/LinkCategory\/[^/]+$/ },
  { titleElakay: "categoryFilterValues", pattern: /^\/filter\/[^/]+\/[^/]+$/ }
];

const getRouteTitleElakay = (pathname) => {
  const cleanPathname = normalizeRoutePathname(pathname);
  const routeTitle = elakayRouteTitleRules.find(({ pattern }) => pattern.test(cleanPathname));

  return routeTitle?.titleElakay || "errorPage";
};

const ElakayRouteTitle = ({ infoSource }) => {
  const { pathname } = useLocation();
  const titleElakay = getRouteTitleElakay(pathname);

  useElakayDocumentTitle(infoSource, titleElakay);
  return null;
};

const buttonTitles = {
  fr: {
    addPhone: "Ajouter un numéro de téléphone",
    deletePhone: "Supprimer ce numéro de téléphone",
    editPhone: "Modifier ce numéro de téléphone",
    addDefaultPhone: "Définir ce numéro comme par défaut",
    phoneCheckedByDefault: "Ce numéro de téléphone est coché par défaut",
    addAddress: "Ajouter une adresse",
    addNewAddress: "Ajouter une nouvelle adresse",
    editAddress: "Modifier cette adresse",
    deleteAddress: "Supprimer cette adresse",
    addDefaultAddress: "Définir cette adresse comme par défaut",
    addressCheckedByDefault: "Cette adresse est cochée par défaut",
    viewShop: "Voir la boutique de ce produit",
    viewProduct: "Voir ce produit",
    addToCart: "Ajouter au panier",
    addToDeal: "Ajouter ce produit à l’offre",
    deleteToDeal: "Retirer ce produit de l’offre", // ✅ ajouté
    editProduct: "Modifier ce produit",
    deleteProduct: "Supprimer ce produit",
    continueSelling: "Continuer le processus de vente de ce produit",
    linkCategory: "Lier cette catégorie à une autre catégorie",
    addLangCategory: "Ajouter toutes les langues à cette catégorie",
    selectPageCategory: "Sélectionner une page pour cette catégorie",
    editCategory: "Modifier cette catégorie",
    deleteCategory: "Supprimer cette catégorie",
    submit: "Soumettre",
    addNew: "Ajouter un nouvel élément",
    editFilter: "Modifier ce filtre",
    addLangFilter: "Ajouter toutes les langues à ce filtre",
    deleteFilter: "Supprimer ce filtre",
    linkFilter: "Lier ce filtre à un autre filtre",
    deleteImage: "Supprimer cette image",
    deleteCategoryImages: "Supprimer les images de cette catégorie",
    addKeyToProduct: "Ajouter cette clé au produit"
  },
  en: {
    addPhone: "Add a phone number",
    deletePhone: "Delete this phone number",
    editPhone: "Edit this phone number",
    addDefaultPhone: "Set this phone number as default",
    phoneCheckedByDefault: "This phone number is checked by default",
    addAddress: "Add an address",
    addNewAddress: "Add a new address",
    editAddress: "Edit this address",
    deleteAddress: "Delete this address",
    addDefaultAddress: "Set this address as default",
    addressCheckedByDefault: "This address is checked by default",
    viewShop: "View this shop for this product",
    viewProduct: "View this product",
    addToCart: "Add to cart",
    addToDeal: "Add this product to deal",
    deleteToDeal: "Remove this product from deal", // ✅ added
    editProduct: "Edit this product",
    deleteProduct: "Delete this product",
    continueSelling: "Continue the selling process for this product",
    linkCategory: "Link this category to another category",
    addLangCategory: "Add all languages to this category",
    selectPageCategory: "Select a page for this category",
    editCategory: "Edit this category",
    deleteCategory: "Delete this category",
    submit: "Submit",
    addNew: "Add a new",
    editFilter: "Edit this filter",
    addLangFilter: "Add all languages to this filter",
    deleteFilter: "Delete this filter",
    linkFilter: "Link filter to another filter",
    deleteImage: "Delete this image",
    deleteCategoryImages: "Delete this category's images",
    addKeyToProduct: "Add this key to the product"
  },
  es: {
    addPhone: "Agregar un número de teléfono",
    deletePhone: "Eliminar este número de teléfono",
    editPhone: "Editar este número de teléfono",
    addDefaultPhone: "Establecer este número como predeterminado",
    phoneCheckedByDefault: "Este número de teléfono está marcado por defecto",
    addAddress: "Agregar una dirección",
    addNewAddress: "Agregar una nueva dirección",
    editAddress: "Editar esta dirección",
    deleteAddress: "Eliminar esta dirección",
    addDefaultAddress: "Establecer esta dirección como predeterminada",
    addressCheckedByDefault: "Esta dirección está marcada por defecto",
    viewShop: "Ver la tienda de este producto",
    viewProduct: "Ver este producto",
    addToCart: "Agregar al carrito",
    addToDeal: "Agregar este producto a la oferta",
    deleteToDeal: "Quitar este producto de la oferta", // ✅ añadido
    editProduct: "Editar este producto",
    deleteProduct: "Eliminar este producto",
    continueSelling: "Continuar el proceso de venta de este producto",
    linkCategory: "Vincular esta categoría con otra categoría",
    addLangCategory: "Agregar todos los idiomas a esta categoría",
    selectPageCategory: "Seleccionar una página para esta categoría",
    editCategory: "Editar esta categoría",
    deleteCategory: "Eliminar esta categoría",
    submit: "Enviar",
    addNew: "Agregar nuevo",
    editFilter: "Editar este filtro",
    addLangFilter: "Agregar todos los idiomas a este filtro",
    deleteFilter: "Eliminar este filtro",
    linkFilter: "Vincular filtro con otro filtro",
    deleteImage: "Eliminar esta imagen",
    deleteCategoryImages: "Eliminar las imágenes de esta categoría",
    addKeyToProduct: "Agregar esta clave al producto"
  },
  ht: {
    addPhone: "Ajoute yon nimewo telefòn",
    deletePhone: "Efase nimewo telefòn sa a",
    editPhone: "Modifye nimewo telefòn sa a",
    addDefaultPhone: "Mete nimewo sa kòm nimewo prensipal",
    phoneCheckedByDefault: "Nimewo telefòn sa make kòm prensipal",
    addAddress: "Ajoute yon adrès",
    addNewAddress: "Ajoute yon nouvo adrès",
    editAddress: "Modifye adrès sa a",
    deleteAddress: "Efase adrès sa a",
    addDefaultAddress: "Mete adrès sa kòm prensipal",
    addressCheckedByDefault: "Adrès sa make kòm prensipal",
    viewShop: "Gade boutik pwodwi sa a",
    viewProduct: "Gade pwodwi sa a",
    addToCart: "Ajoute nan panyen",
    addToDeal: "Ajoute pwodwi sa nan òf la",
    deleteToDeal: "Retire pwodwi sa nan òf la", // ✅ ajoute
    editProduct: "Modifye pwodwi sa a",
    deleteProduct: "Efase pwodwi sa a",
    continueSelling: "Kontinye pwosesis vant pwodwi sa a",
    linkCategory: "Lye kategori sa ak yon lòt kategori",
    addLangCategory: "Ajoute tout lang nan kategori sa a",
    selectPageCategory: "Chwazi yon paj pou kategori sa a",
    editCategory: "Modifye kategori sa a",
    deleteCategory: "Efase kategori sa a",
    submit: "Soumèt",
    addNew: "Ajoute nouvo",
    editFilter: "Modifye filtè sa a",
    addLangFilter: "Ajoute tout lang nan filtè sa a",
    deleteFilter: "Efase filtè sa a",
    linkFilter: "Lye filtè sa ak yon lòt filtè",
    deleteImage: "Efase imaj sa a",
    deleteCategoryImages: "Efase imaj kategori sa a",
    addKeyToProduct: "Ajoute kle sa nan pwodwi a"
  },
  pt: {
    addPhone: "Adicionar um número de telefone",
    deletePhone: "Excluir este número de telefone",
    editPhone: "Editar este número de telefone",
    addDefaultPhone: "Definir este número como padrão",
    phoneCheckedByDefault: "Este número de telefone está marcado como padrão",
    addAddress: "Adicionar um endereço",
    addNewAddress: "Adicionar um novo endereço",
    editAddress: "Editar este endereço",
    deleteAddress: "Excluir este endereço",
    addDefaultAddress: "Definir este endereço como padrão",
    addressCheckedByDefault: "Este endereço está marcado como padrão",
    viewShop: "Ver a loja deste produto",
    viewProduct: "Ver este produto",
    addToCart: "Adicionar ao carrinho",
    addToDeal: "Adicionar este produto à oferta",
    deleteToDeal: "Remover este produto da oferta", // ✅ adicionado
    editProduct: "Editar este produto",
    deleteProduct: "Excluir este produto",
    continueSelling: "Continuar o processo de venda deste produto",
    linkCategory: "Vincular esta categoria a outra categoria",
    addLangCategory: "Adicionar todos os idiomas a esta categoria",
    selectPageCategory: "Selecionar uma página para esta categoria",
    editCategory: "Editar esta categoria",
    deleteCategory: "Excluir esta categoria",
    submit: "Enviar",
    addNew: "Adicionar novo",
    editFilter: "Editar este filtro",
    addLangFilter: "Adicionar todos os idiomas a este filtro",
    deleteFilter: "Excluir este filtro",
    linkFilter: "Vincular filtro a outro filtro",
    deleteImage: "Excluir esta imagem",
    deleteCategoryImages: "Excluir imagens desta categoria",
    addKeyToProduct: "Adicionar esta chave ao produto"
  }
};

const allEnabled = {
            preset: "allEnabled",
            globalAnimations: true,
            reducedMotion: false,
            motionStability: { enabled: false },
            appPwa: { ...DEFAULT_APP_PWA },
            menuSliderBar: {
                enableBarAnimation: true,
                enableButtonAnimations: true,
                enableIconAnimations: true,
                enableMenuAnimations: true,
                enableHoverAnimations: true,
                showMobileQuickMenu: true
            },
            layout: {
                enableBodyParticles: true,
                enableFloatingSquares: true,
                enableContentFadeIn: true,
                particlesCount: 30,
                squaresCount: 10
            },
            header: {
                enableHeaderAnimations: true,
                enableLogoAnimation: true,
                enableSearchAnimation: true,
                enableMenuAnimation: true,
                enableNavigationItemAnimations: true,
                enableNavigationIconAnimations: true,
                enableLanguageAnimation: true,
                enableUserAnimation: true,
                enableCartAnimation: true,
                enableShineEffect: true,
                enableBreathEffect: true,
                enableHoverAnimations: true
            },
            footer: {
                enableFooterAnimations: true,
                enableSectionAnimations: true,
                enableItemAnimations: true,
                enableHoverAnimations: true,
                enableButtonAnimations: true,
                enableIconAnimations: true,
                enableBackgroundGrid: true,
                enableGradientOverlay: true,
                enableShineEffect: true,
                enableScrollAnimations: true,
                enableStaggeredAnimations: true,
                enableFloatingParticles: true,
                enableRippleEffect: true,
                enableTitleAnimations: true,
                enableLinkAnimations: true,
                enableDividerAnimations: true,
                enableCopyrightAnimations: true
            }
        }

         let   allDisabled = {
            preset: "allDisabled",
            globalAnimations: false,
            reducedMotion: true,
            motionStability: { enabled: false },
            menuSliderBar: {
                enableBarAnimation: false,
                enableButtonAnimations: false,
                enableIconAnimations: false,
                enableMenuAnimations: false,
                enableHoverAnimations: false,
                showMobileQuickMenu: true
            },
            shopPicker: {
                showElakayShops: false,
                elakayShopsExpiresAt: null
            },
            wallet: {
                usePaymentIntentIncome: false
            },
            layout: {
                enableBodyParticles: false,
                enableFloatingSquares: false,
                enableContentFadeIn: false,
                particlesCount: 0,
                squaresCount: 0
            },
            header: {
                enableHeaderAnimations: false,
                enableLogoAnimation: false,
                enableSearchAnimation: false,
                enableMenuAnimation: false,
                enableNavigationItemAnimations: false,
                enableNavigationIconAnimations: false,
                enableLanguageAnimation: false,
                enableUserAnimation: false,
                enableCartAnimation: false,
                enableShineEffect: false,
                enableBreathEffect: false,
                enableHoverAnimations: false
            },
            footer: {
                enableFooterAnimations: false,
                enableSectionAnimations: false,
                enableItemAnimations: false,
                enableHoverAnimations: false,
                enableButtonAnimations: false,
                enableIconAnimations: false,
                enableBackgroundGrid: false,
                enableGradientOverlay: false,
                enableShineEffect: false,
                enableScrollAnimations: false,
                enableStaggeredAnimations: false,
                enableFloatingParticles: false,
                enableRippleEffect: false,
                enableTitleAnimations: false,
                enableLinkAnimations: false,
                enableDividerAnimations: false,
                enableCopyrightAnimations: false
            }
        }
const TruncatedText = (
   { text = 'Loading...',
    limits = [100, 50],
    showToggle = true,
    delay = 300 // temps avant d'afficher le texte
    }
) => {

    const isMobile = window.innerWidth <= 768;
    const maxChars = isMobile ? limits[1] : limits[0];

    const [expanded, setExpanded] = React.useState(false);
    const [loading, setLoading] = React.useState(true);

    // Injecter le CSS seulement une fois
    React.useEffect(() => {
        if (!document.getElementById("truncated-text-style")) {
            const style = document.createElement("style");
            style.id = "truncated-text-style";
            style.innerHTML = `
                .dots-loading::after {
                    content: "";
                    animation: dotsAnim 1.5s steps(4, end) infinite;
                }

                @keyframes dotsAnim {
                    0% { content: ""; }
                    25% { content: "."; }
                    50% { content: ".."; }
                    75% { content: "..."; }
                    100% { content: ""; }
                }
            `;
            document.head.appendChild(style);
        }
    }, []);

    // Loading delay
    React.useEffect(() => {
        const timer = setTimeout(() => setLoading(false), delay);
        return () => clearTimeout(timer);
    }, [text]);

    if (loading) {
        return (
            <span style={{ color: "#64748b", opacity: 0.8, fontStyle: "italic" }}>
                <span className="dots-loading">{elakayAutoText("h_b04ba49f848624", "Loading...")}</span>
            </span>
        );
    }

    // Gestion du texte tronqué
    const shouldTruncate = text.length > maxChars;
    const visibleText =
        expanded || !shouldTruncate
            ? text + "..."
            : text.substring(0, maxChars) + "...";

    return (
        <span>
            <span
                dangerouslySetInnerHTML={{ __html: visibleText }}
            />

            {showToggle && shouldTruncate && (
                <button
                    onClick={() => setExpanded(!expanded)}
                    style={{
                        border: "none",
                        background: "transparent",
                        color: "#0ea5e9",
                        marginLeft: "6px",
                        cursor: "pointer",
                        fontWeight: 500,
                        padding: 0,
                        fontSize: "0.9rem"
                    }}
                >
                    {expanded ? elakayAutoText("h_47c77bf0a809f2", "See less") : elakayAutoText("h_c510d6c04c0951", "See more")}
                </button>
            )}
        </span>
    );
};


const RoutesElakay = () => { 
    const [getPromoInfo, setPromoInfo] = useState({pubShow: true, pub})
    const [languageAPI, setLanguageAPI] = useState([]); 
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]); 
    const [getpub, setPub] = useState([{ "urlImg": Loader1, "_id":1}]);
    const [filters, setFilters] = useState([]); 
    const [userInfo, setUserInfo] = useState({});
    const [getCartItems, setgetCart] = useState([])
    // Cart lines no longer for sale (deleted, deleted by their Provider...): shown with a notice, never charged.
    const [cartUnavailable, setCartUnavailable] = useState([])
    const [getTrashItems, setGetTrash] = useState([])
    const [trashCount, setTrashCount] = useState(0)
    // Email Inbox unread badge (spec §11-13): exact same plumbing shape as
    // trashCount above -- init once, refresh on window focus + a custom
    // event (dispatched after a new campaign is sent to this user, or after
    // an email is opened/marked read), exposed to the tree via infoSource.
    const [unreadEmailCount, setUnreadEmailCount] = useState(0)
    const [userRole, setUserRole] = useState([]);
    const [address, setAddress] = useState([]);
    const [phoneUser, setPhoneUser] = useState([]);
    const [elakayCategories, setElakayCategories] = useState([]);
    const [userAdmin, setUserAdmin] = useState([]);
    // Switch Role / View As Role (Phase 1) -- selectedRole is the OPTIONAL
    // view overlay (null = Default/current behavior, spec §1-§2);
    // allowedSwitchRoles comes from the backend's own readMe response
    // (roleSwitch.allowedSwitchRoles), never computed client-side alone, so
    // the dropdown can never offer a role the server wouldn't also allow.
    const [selectedRole, setSelectedRole] = useState(null);
    const [allowedSwitchRoles, setAllowedSwitchRoles] = useState([]);
    const [realRole, setRealRole] = useState(null);
    // Permission Center: individual page permissions, already filtered by the
    // server in /readMe (display and navigation only; every API re-checks).
    const [individualPermissions, setIndividualPermissions] = useState([]);
    const [permissionCenterOwner, setPermissionCenterOwner] = useState(false);
    const { token } = isAuthenticated();
    const [loading, setLoading] = useState(true);
    const [showConditionsRole, setConditionsRole] = useState(false);
    const [getShopFollow, setShopFollow] = useState([])
    const [getPubToken, setPubToken] = useState([])
  const [allSettings, setAllsettings] = useState(allDisabled)

    // Applique le "Default Title Style" (AnimationSettings → General) en CSS
    // custom properties globales dès que les réglages sont chargés/modifiés.
    useEffect(() => {
        applyDefaultTitleStyleVars(allSettings?.defaultTitleStyle);
    }, [allSettings?.defaultTitleStyle]);

    useEffect(() => {
        applyAppPwaSettings(allSettings?.appPwa);
        const refresh = () => applyAppPwaSettings(allSettings?.appPwa);
        window.addEventListener('resize', refresh);
        return () => window.removeEventListener('resize', refresh);
    }, [allSettings?.appPwa]);

    const [location, setLocation] = useState({
        latitude: null,
        longitude: null,
        accuracy: null,
        timestamp: null,
        country: null,
        countryCode: null,
        city: null,
        state: null,
        zipCode: null,
        attribution: null,
        requested: false,
        loading: false,
        error: null
    })

  const divFollowSliderMatrix  = useRef(null);
  const divProdGridPage = useRef(null);
  const pageTopRef = useRef(null);

  useEffect(() => {
    const animationsEnabled = allSettings?.globalAnimations === true;
    document.documentElement.classList.toggle('elakay-animations-disabled', !animationsEnabled);
  }, [allSettings?.globalAnimations]);

  useEffect(() => {
    const stabilityEnabled = allSettings?.motionStability?.enabled === true;
    document.documentElement.classList.toggle('elakay-motion-stable', stabilityEnabled);
    return () => document.documentElement.classList.remove('elakay-motion-stable');
  }, [allSettings?.motionStability?.enabled]);

  const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ 
                            behavior: 'smooth',
                            block: 'start', 
                            inline: 'nearest'
                           });
      }};

    const {
        device, 
        model, 
        browser, 
        navigation,
        headShop
        } = allDeviceUserArgent()

const getAddressFromCoordinates = async (latitude, longitude) => {
  const reverseGeocodingUrl = new URL(
    process.env.REACT_APP_REVERSE_GEOCODING_URL ||
      "https://nominatim.openstreetmap.org/reverse"
  );

  reverseGeocodingUrl.search = new URLSearchParams({
    format: "jsonv2",
    lat: latitude.toString(),
    lon: longitude.toString(),
    addressdetails: "1",
    layer: "address",
    "accept-language": navigator.language || "en"
  }).toString();

  const response = await fetch(reverseGeocodingUrl.toString(), {
    headers: {
      Accept: "application/json"
    }
  });

  if (!response.ok) {
    throw new Error(`Reverse geocoding failed with status ${response.status}.`);
  }

  const data = await response.json();
  const address = data.address || {};

  return {
    country: address.country || null,
    countryCode: address.country_code?.toUpperCase() || null,
    city:
      address.city ||
      address.town ||
      address.village ||
      address.municipality ||
      address.hamlet ||
      address.county ||
      null,
    state: address.state || address.region || null,
    zipCode: address.postcode || null,
    attribution: data.licence || "Data from OpenStreetMap contributors"
  };
};

const getLocation = async (options = {}) => {
  if (typeof navigator === "undefined" || !navigator.geolocation) {
    const error = {
      code: "GEOLOCATION_UNAVAILABLE",
      message: elakayAutoText("h_63502d3c8b7998", "Geolocation is not supported by this browser.")
    };

    setLocation((currentLocation) => ({
      ...currentLocation,
      requested: true,
      loading: false,
      error
    }));
    throw error;
  }

  setLocation((currentLocation) => ({
    ...currentLocation,
    requested: true,
    loading: true,
    error: null
  }));

  let coordinates;
  try {
    coordinates = await requestCurrentPosition({
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 60000,
      ...options
    });
  } catch (geolocationError) {
    const error = {
      code: geolocationError.code,
      message: geolocationError.message || elakayAutoText(
        "h_871671c21b3af9",
        "Unable to retrieve the current location."
      )
    };

    setLocation((currentLocation) => ({
      ...currentLocation,
      loading: false,
      error
    }));
    throw error;
  }

  try {
    const address = await getAddressFromCoordinates(
      coordinates.latitude,
      coordinates.longitude
    );
    const currentLocation = {
      ...coordinates,
      ...address,
      requested: true,
      loading: false,
      error: null
    };

    setLocation(currentLocation);
    return currentLocation;
  } catch (reverseGeocodingError) {
    const error = {
      code: "REVERSE_GEOCODING_FAILED",
      message:
        reverseGeocodingError.message ||
        "Unable to retrieve the address for the current location."
    };
    const currentLocation = {
      ...coordinates,
      country: null,
      countryCode: null,
      city: null,
      state: null,
      zipCode: null,
      attribution: null,
      requested: true,
      loading: false,
      error
    };

    setLocation(currentLocation);
    throw error;
  }
};



const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const didInit_3 = useRef(false);
  useEffect(() => {
     if (didInit_3.current) return;
         didInit_3.current = true;
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // cleanup
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline
}
        
// const readUser = async (token) => {
//   if (!token) return;

//   try {
//     const encryptedData = await readMe(token);
//     const data = encryptedData;
//     if (data.error) {
//           signout(token);
//     // window.location.href = '/signin';
//     } else {
//       setUserInfo(data.user);
//       setAddress(data.address);
//       setUserRole(data.role);
//       setPhoneUser(data.telephone);
//       setShopFollow(data.user.followShopUser);
//       setUserAdmin(data.user.userActiveRole.userAdmin);
//       setPubToken(data.user.Pub);

//       if (data.role.role !== null && data.role.agreeRole === false) {
//         setConditionsRole(true);
//       }
//     }
//   } catch (err) {
//     console.error("Erreur lors du chargement de l'utilisateur :", err);
//   }
// };

const readUser = async (token, facets = []) => {
  if (!token) return null;

  try {
    const data = await readMe(token);
    if (data?.error) {
      // Only an administrative suspension ends the session here. A refused
      // token (401) is handled once, app-wide, by sessionGuard; a network or
      // server failure (backend restarting, 5xx) used to sign a valid user
      // out -- the session is kept and the next load simply retries.
      if (data.status === 403 && data.errorCode === "ACCOUNT_SUSPENDED") signout(token);
      return null;
    }
    const loadAll = !Array.isArray(facets) || facets.length === 0;

    if (loadAll || facets.includes("getUserInfo")) {
      setUserInfo(data?.user || {});
    }

    if (loadAll || facets.includes("getAddress")) {
      setAddress(data?.address || []);
    }

    if (loadAll || facets.includes("getPhoneUser")) {
      setPhoneUser(data?.telephone || []);
    }

    if (loadAll || facets.includes("getUserRole")) {
      setUserRole(data?.role || []);

      if (data?.role?.role !== null && data?.role?.agreeRole === false) {
        setConditionsRole(true);
      } else {
        setConditionsRole(false);
      }

      // Switch Role / View As Role (Phase 1) -- revalidate the persisted
      // choice against the backend's own freshly-computed allow-list on
      // every load (spec §11: never trust localStorage alone). A choice
      // that's no longer valid (role changed, demoted, etc.) is silently
      // discarded back to Default -- never an error toast.
      //
      // realRole comes from roleSwitch.realRole (always the account's true
      // role, computed server-side before any override -- see auth.js),
      // NOT from data.role/data.user.userActiveRole, which readMe
      // deliberately keeps as the real role too, but roleSwitch.realRole is
      // the one explicit, purpose-built field for this. Exposed via
      // infoSource so any consumer needing the real/effective split
      // explicitly can use getRoleContext(infoSource) (Rolle.js) instead of
      // re-deriving it.
      const allowed = data?.roleSwitch?.allowedSwitchRoles || [];
      const persisted = getPersistedSelectedRole();
      const validSelectedRole = persisted && allowed.includes(persisted) ? persisted : null;
      setSelectedRole(validSelectedRole);
      setAllowedSwitchRoles(allowed);
      setRealRole(data?.roleSwitch?.realRole?.roleName || null);
      setIndividualPermissions(Array.isArray(data?.individualPermissions) ? data.individualPermissions : []);
      setPermissionCenterOwner(data?.permissionCenterOwner === true);
      setSelectedRoleOverride(validSelectedRole, allowed);
      if (persisted && !validSelectedRole) clearPersistedSelectedRole();
    }

    if (loadAll || facets.includes("getShopFollow")) {
      setShopFollow(data?.user?.followShopUser || []);
    }

    if (loadAll || facets.includes("getUserAdmin")) {
      setUserAdmin(data?.user?.userActiveRole?.userAdmin || []);
    }

    if (loadAll || facets.includes("getPubToken")) {
      setPubToken(data?.user?.Pub || []);
    }

    return data;
  } catch (err) {
    console.error("Erreur lors du chargement de l'utilisateur :", err);
    return null;
  }
};

      const loadCategory = async (IdSel) => {
          let ID = IdSel ? IdSel: FirtIDCategory
           try {

              const encryptedData = await getCategoriesByID(ID);
              const data = encryptedData;
                 if (data.error) {
                    throw new Error("data Not Found")
                    } else {
                    setCategories(data.cartegory)
                    setItems(data.items)
                    setFilters(data.filter)
                    setPub(data.pub?.length > 0 ? data.pub : [{ "urlImg": imgLakay1, "_id": 1 }, { "urlImg": imgLakay2, "_id": 2 }, { "urlImg": imgLakay3, "_id": 3 }])
                    elakayCategories?.length <= 0 && setElakayCategories(data.items)
                }

           } catch (err) {
    console.error("Erreur lors du chargement de l'utilisateur :", err);
  }
  }

        const cartItems = async (token) => {
            if (!token) return;
            try {
                const data = await getCart(token);
                if (!data) {
                } else {
                    setgetCart(data.cart);
                    setCartUnavailable(Array.isArray(data.unavailable) ? data.unavailable : []);
                }
            } catch (err) {
                console.error("Erreur lors du chargement du panier :", err);
            }
        }

        // Même patron que cartItems ci-dessus -- alimente le badge/bouton
        // flottant Trash (Header.js) et se rafraîchit après chaque action de
        // corbeille (softDelete/restore/permanentDelete, voir Card.js/cardTable.jsx).
        // Vide (tableau []) pour un acheteur sans produits en vente : le bouton
        // reste alors invisible, aucun rôle vendeur à vérifier explicitement.
        const trashItems = async (token) => {
            if (!token) {
                setGetTrash([]);
                setTrashCount(0);
                return;
            }
            try {
                // Un seul produit suffit pour l'aperçu. Le badge utilise le
                // total paginé renvoyé par l'API, jamais la taille de la page.
                const data = await getTrashProducts(token, 0, 1);
                if (!data || data.error) {
                } else {
                    setGetTrash(data.products || []);
                    setTrashCount(Number(data.siseProduct) || 0);
                }
            } catch (err) {
                console.error("Erreur lors du chargement de la corbeille :", err);
            }
        }

        // Email Inbox unread badge (spec §11-13): same shape as trashItems
        // above -- feeds FloatingEmailInboxIcon + the User Menu/Footer badge.
        // Empty/0 for a logged-out visitor (no Inbox concept without an
        // account) -- the floating icon itself hides completely at 0.
        const emailInboxUnreadItems = async (token) => {
            if (!token) {
                setUnreadEmailCount(0);
                return;
            }
            try {
                const data = await getEmailInboxUnreadCountAPI(token);
                if (!data || data.error) {
                } else {
                    setUnreadEmailCount(Number(data.unreadCount) || 0);
                }
            } catch (err) {
                console.error("Erreur lors du chargement du compteur Email Inbox :", err);
            }
        }


   
  const didInit_4 = useRef(false);
        useEffect(() => {
        if (didInit_4.current) return;
         didInit_4.current = true;
         laodingAnimationSettings()
            readUser(token)
            cartItems(token)
            // trash + Email Inbox counters: loaded by their own [token]
            // effects below (they used to be requested twice at startup).
            loadCategory()
            getLangaugeAPI()
        }, []);

        // Le token peut être disponible après le premier rendu. Cette écoute
        // évite que le compteur reste définitivement à zéro dans ce cas et le
        // resynchronise aussi au retour sur l'onglet.
        useEffect(() => {
            trashItems(token);
            const refreshTrash = () => trashItems(token);
            window.addEventListener('focus', refreshTrash);
            window.addEventListener('elakay:trash-changed', refreshTrash);
            return () => {
                window.removeEventListener('focus', refreshTrash);
                window.removeEventListener('elakay:trash-changed', refreshTrash);
            };
        }, [token]);

        // Same focus/custom-event resync as trashItems above --
        // 'elakay:email-inbox-changed' is dispatched by the Email Inbox page
        // after marking one/all emails read (see emailInboxPage.jsx), so the
        // floating icon/badge disappear without a full page refresh.
        useEffect(() => {
            emailInboxUnreadItems(token);
            const refreshEmailInbox = () => emailInboxUnreadItems(token);
            window.addEventListener('focus', refreshEmailInbox);
            window.addEventListener('elakay:email-inbox-changed', refreshEmailInbox);
            return () => {
                window.removeEventListener('focus', refreshEmailInbox);
                window.removeEventListener('elakay:email-inbox-changed', refreshEmailInbox);
            };
        }, [token]);

            const checkProdKeyExit = (api, elJSON, key) => (
                effectiveLanguageSection(api, elJSON, key)
            )
        
        const checkLangDefault = (a, b, c)=>{
            return checkProdKeyExit(a, b)
         }

         const checkLangObjDefault = (a, b, c)=>{
           return checkProdKeyExit(a, b, c)
         }

         const getCategoryNames = (data, racine = false)=>{
            let enLang = racine? data:  data?.supCategoryID
            let translations = racine? data?.lang :  data?.supCategoryID?.lang  
           
            const {obj} = getElakayLang();
            const {code }= obj
            let checkLang = translations === undefined || !translations || Object?.keys(translations)?.length === 0

            // 1) Si la langue est 'en', on retourne la clé "en" si elle existe.
            if(code == 'en'){
                return enLang || {}
            }
         // 2) Si l'objet translations est vide ou non défini, on retourne un objet vide ou la clé "en".
            if (checkLang) {
                return enLang || {}; // ou translations.en, selon votre préférence
            }
             // 3) Sinon, on essaie de retourner la langue sélectionnée.
            //    Si elle n'existe pas, on retourne 'en' par défaut.
            return translations[code] || enLang
        
         }

         const getFilTranslate = (data)=>{
          
            let fil = data._id.name? data._id : data
            let translations = fil.lang
            let itemsInEnglish  =  data.Filters?.length === 0 ? fil.FilterItem : data.Filters
            const {obj} = getElakayLang();
            const {code }= obj
            let checkLang = translations === undefined || !translations || Object.keys(translations)?.length === 0

            // 1) Si la langue n'existe pas, on force "en"
            // const lang = checkLang && translations[code] ? code : "en";
            const lang = code === "en" && !checkLang ? "en" : code

            // 2) Récupère le name et FilterItem en anglais et dans la langue cible
            const enName = fil.name || "";
            const enArray = fil.FilterItem || [];

            const targetName = code === "en" ?  enName : !checkLang ? translations[lang].name : enName;
            const targetArray = code === "en" ? enArray : !checkLang ? translations[lang].FilterItem : enArray;

    
    // Cas c) Si englesh selected as "en",
  //        on veut retourner enArray sous forme de matrice triée.
  // -----------------------------------------------------------------------------------
  if (code == 'en') {
    // On transforme enArray => [ [val, val], [val, val], ... ]
    let matrix = enArray?.map((val) => [val, val]);

    // On trie la matrice sur le second élément (index 1)
    matrix.sort((a, b) => {
      if (a[1] < b[1]) return -1;
      if (a[1] > b[1]) return 1;
      return 0;
    });

    // On retourne le name enName et la matrice
    return {
      name: enName,
      FilterItem: matrix
    };
  }

    // Cas A) Si `checkLang` est TRUE,
  //        on veut retourner enArray sous forme de matrice triée.
  // -----------------------------------------------------------------------------------
  if (checkLang) {
    // On transforme enArray => [ [val, val], [val, val], ... ]
    let matrix = enArray?.map((val) => [val, val]);

    // On trie la matrice sur le second élément (index 1)
    matrix.sort((a, b) => {
      if (a[1] < b[1]) return -1;
      if (a[1] > b[1]) return 1;
      return 0;
    });

    // On retourne le name enName et la matrice
    return {
      name: enName,
      FilterItem: matrix
    };
  }

  const matrix = itemsInEnglish?.map((item) => {
    const indexEn = enArray.indexOf(item);
    if (indexEn !== -1) {
      return [item, targetArray[indexEn]];
    }
    // Si l'item n'existe pas dans enArray, on fait une paire doublée
    return [item, item];
  });

  // On trie la matrice sur la 2e colonne (la valeur cible)
  matrix.sort((a, b) => {
    if (a[1] < b[1]) return -1;
    if (a[1] > b[1]) return 1;
    return 0;
  });

  // Retour de la matrice
  return {
    name: targetName,
    FilterItem: matrix
  };
        
         }

      const laodingAnimationSettings = async () => {
        try {
          const encryptedData = await getFirstAnimationSettingsAPI();
          const data = encryptedData;
          if (data.error) {
            setAllsettings(allDisabled);
          } else {
            setAllsettings(data.settings);
          }
        } catch (err) {
          console.error("Error loading animation settings:", err);
        }
      }

         const getLangaugeAPI = async () =>{
            const {obj} = getElakayLang();
            // let elakayInfo = menuElakay[0]
            let elakayInfo = await loadMenuLanguage(obj?.code);
            if(obj){ 
          await LanguageElakayByLanguage(obj , false).then(data => {
                if (data.error) {
                    // SetElakayLang({"code":"en","name":"English","nativeName":"English"}, 0)
                    setLanguageAPI({elakayInfo, elakayInfoAPI:{}, checkLangDefault, checkLangObjDefault})
                    setLoading(false)
                } else {
                 setLanguageAPI({elakayInfo, elakayInfoAPI: data, checkLangDefault, checkLangObjDefault,  loading: false})
                  setLoading(false)
                }
            }).catch(err => {
                console.error("Erreur lors du chargement de la langue :", err);
                setLanguageAPI({elakayInfo, elakayInfoAPI:{}, checkLangDefault, checkLangObjDefault})
                setLoading(false);
            });
        }else{
            SetElakayLang({"code":"en","name":"English","nativeName":"English"}, 0)  
            setLanguageAPI({elakayInfo, elakayInfoAPI:{}, checkLangDefault, checkLangObjDefault,  loading: false})
            setLoading(false)
        }
        
         }

        useEffect(() => {
            const refreshLanguage = () => getLangaugeAPI();
            window.addEventListener("elakay:language-changed", refreshLanguage);
            return () => window.removeEventListener("elakay:language-changed", refreshLanguage);
        });
       
         let styleNav = {
            width: '100%', 
            overflowX: 'hidden', 
            overflowY: 'auto',
            position: 'relative',
            margin: 0,
            padding: 0,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
             }

 const getButtonTitle =(key)=>{
  // No stored language yet, or one without titles: English (the old
  // `code = 'en'` reassigned a const and threw instead).
  const storedCode = getElakayLang()?.obj?.code;
  const code = buttonTitles[storedCode] ? storedCode : 'en'; // langue par défaut
  return buttonTitles[code][key] || buttonTitles['en'][key] || key;
}

        const infoSource = {
                            token,
                            showConditionsRole, 
                            setConditionsRole,
                            getShopFollow,
                            setShopFollow,
                            categories,
                            items,
                            filters,
                            getCartItems,
                            cartUnavailable,
                            cartItems,
                            getTrashItems,
                            trashCount,
                            trashItems,
                            unreadEmailCount,
                            userInfo,
                            userAdmin,
                            address,
                            phoneUser,
                            setPhoneUser,
                            userRole,
                            selectedRole,
                            setSelectedRole,
                            allowedSwitchRoles,
                            realRole,
                            individualPermissions,
                            permissionCenterOwner,
                            refreshIndividualPermissions: () => token && readUser(token, ["getUserRole"]),
                            isRoleSwitchActive: !!selectedRole,
                            elakayCategories,
                            getPubToken,
                            setCategories,
                            setItems,
                            setFilters,
                            loadCategory,
                            readUser,
                            getpub,
                            loading,
                            getLangaugeAPI,
                            languageAPI,
                            navigation,
                            device,
                            headShop,
                            styleNav,
                            getButtonTitle,
                            laguangeElakay,
                            getCategoryNames,
                            getFilTranslate,
                            language,
                            getPromoInfo, 
                            setPromoInfo,
                            NetworkStatus,
                            location,
                            getLocation,
                            TruncatedText,
                            animationConfigData,
                            allSettings,
                            reloadAnimationSettings: laodingAnimationSettings,
                            allEnabled,
                            allDisabled,
                            logoElakay,
                            imageEmptyelakay,
                            elakay_logo_loading,
                            divFollowSliderMatrix,
                            divProdGridPage,
                            pageTopRef,
                            scrollToParagraph
                            } 
        setElakayLanguageContext(infoSource);

     return (
        !loading && <BrowserRouter>
              <ElakayRouteTitle infoSource={infoSource} />
              <NavigationHistoryTracker />
              <HeaderFooterThemeSync infoSource={infoSource} />
              <PresenceBeacon />
              <Suspense fallback={<div role="status" aria-live="polite" style={{ padding: 24, textAlign: "center" }}>{elakayAutoText("h_b04ba49f848624", "Loading...")}</div>}>
              <Routes>
                 {/* ---------- user --------- */}
                 <Route path="/image/logoElakayIco.ico" element={<img style={{ width: "50%" }} src={logoElakay} alt={elakayAutoText("h_091c0f9a11d5e2", "logo elakay")}/>} />  
                   {/* ---------- user --------- */}
                       <Route path="/signin" element={<Signin infoSource={infoSource} {...allSettings?.signin} />} />
                       <Route path="/signup" element={<Signup infoSource={infoSource} {...allSettings?.signup} />} />
                       <Route path="/active/:token" element={<Active infoSource={infoSource} {...allSettings?.active} />} />
                       <Route path="/forget-password" element={<ForgetPassword infoSource={infoSource} {...allSettings?.forgetPassword} />} />
                       <Route path="/password/:token" element={<Password infoSource={infoSource} {...allSettings?.userPasswordChange} />} />
                        <Route path="/userPUB/:token" element={<PromotionEntry infoSource={infoSource} />} />
                        
                   {/* ----------------Page for All User---------------------- */}
                
                  <Route path="/" element={<Home infoSource ={infoSource} />} /> 
                 
                 <Route path="/product/preview/:productId" element={<ProductPreview infoSource ={infoSource} />}/>
                 <Route path="/new-product" element={<NewProduct infoSource ={infoSource}/>}/>
                 <Route path="/best-sellers" element={<BestSellers infoSource ={infoSource} />} />
                 <Route path="/product/:categoryId" element={<ProductCatalog infoSource ={infoSource} />} />
                <Route path="/search" element={<Search infoSource ={infoSource} />} />
                 <Route path="/all-catageories" element={<AllCategories infoSource ={infoSource} />}/>
                 <Route path="/help-contact" element={<HelpContart infoSource ={infoSource} />} />
                <Route path="/deal-today" element={<DealToday infoSource ={infoSource} />} />
                <Route path="/investments" element={<Investments infoSource ={infoSource} />} />
                <Route path="/investments/:slug" element={<InvestmentDetail infoSource ={infoSource} />} />
                <Route path="/jobs" element={<Jobs infoSource ={infoSource} />} />
                <Route path="/jobs/:slug" element={<JobDetail infoSource ={infoSource} />} />
                <Route path="/how-we-do-it" element={<HowWeDoIt infoSource ={infoSource} />} />
                <Route path="/how-we-do-it/:slug" element={<HowWeDoItDetail infoSource ={infoSource} />} />
                <Route path="/how-to-Step" element={<HowToStep infoSource ={infoSource} />}/>
                <Route path="/lakay-ShopSeller/:id" element={<ShopUser infoSource ={infoSource} />}/>
                <Route path="/lakay-ShopSeller/:id/about" element={<ShopAboutPage infoSource={infoSource} />}/>
                {/* Social Media Marketing (spec §3, §17, §20): the "Dynamic"
                    Publication Mode's human-facing route only -- a social
                    crawler is served the real HTML directly by
                    server_elakay's /elakay_api/marketing/:id and never
                    reaches this route. No auth wrapper (must work "sans
                    authentification"). */}
                <Route path="/marketing/:campaignId" element={<PublicMarketingPage />}/>
                  <Route path="*" element={<ErrorPage infoSource ={infoSource}/>} />


                 {/* ---------Page for All us er Sing in---------- */}

                 <Route path="/your-step" element={<UserSignin> <Step infoSource ={infoSource} /></UserSignin>} />
                 {/* Seller/Provider/Simple Promotion Token entry point — /user-step?t=TOKEN */}
                 <Route path="/user-step" element={<EventStepAuthGate infoSource={infoSource}><Step infoSource ={infoSource} /></EventStepAuthGate>} />
                 <Route path="/cart" element={<UserSignin> <Cart infoSource ={infoSource} /> </UserSignin>} />
                 <Route path="/user-viewed" element={<UserSignin> <UserView infoSource ={infoSource}/> </UserSignin>}/>
                {/* Section-level "See More" — ALL cards for that section.
                    Each card's own link still opens /product/:categoryId
                    (or /lakay-ShopSeller/:owner for Shops You Follow) —
                    unrelated to these routes. */}
                <Route path="/search-history" element={<UserSignin> <SearchHistoryAllCards infoSource ={infoSource}/> </UserSignin>}/>
                <Route path="/viewing-activity" element={<UserSignin> <ViewingActivityAllCards infoSource ={infoSource}/> </UserSignin>}/>
                <Route path="/shops-you-follow" element={<UserSignin> <ShopsYouFollowAllCards infoSource ={infoSource}/> </UserSignin>}/>
                 <Route path="/profile" element={<UserSignin> <Profile infoSource ={infoSource} /> </UserSignin>} />
                 <Route path="/c/orders" element={<UserSignin> <Orders infoSource ={infoSource}/> </UserSignin>}/>
                 <Route path="/account" element={<UserSignin> <Account infoSource ={infoSource}/> </UserSignin>} />
                 <Route path="/account/settings" element={<UserSignin> <AccountSettings infoSource={infoSource} /> </UserSignin>} />
                 <Route path="/purchased" element={<UserSignin> <Purchased infoSource ={infoSource}/> </UserSignin>} />
                 <Route path="/message" element={<UserSignin> <Message infoSource ={infoSource}/> </UserSignin>} />
                 <Route path="/contact-requests" element={<UserSignin> <ContactRequestsInbox infoSource ={infoSource}/> </UserSignin>} />
                 <Route path="/my-job-applications" element={<UserSignin> <MyJobApplications infoSource ={infoSource}/> </UserSignin>} />
                 <Route path="/wallet" element={<UserSignin> <Wallet infoSource ={infoSource}/> </UserSignin>}/>

                 {/* ---------Page for All Seller, Provider, Admin, Family---------- */}
                 <Route path="/user-setting" element={<UserSignin><UserSerting infoSource ={infoSource}/></UserSignin>} />
                 <Route path="/user-serting" element={<Navigate to="/user-setting" replace />} />

                 {/* Seller workspace: unchanged for Seller and the Combined Sell Center roles; an effective
                     Provider is sent to Provider Center instead (direct URL / bookmark / shared link
                     included) -- see includes/auth/sellerWorkspaceRoute.js. Paths are case-insensitive,
                     so /myshop, /myShop, /MyShop... all land here. */}
                 <Route path="/myShop" element={<SellerMyShopRoute infoSource={infoSource}><UserProduct infoSource ={infoSource}/></SellerMyShopRoute>} />
                 <Route path="/product/edit/:productId" element={<SellerProductEditRoute infoSource={infoSource}><EditProduct infoSource ={infoSource}/></SellerProductEditRoute>} />
                 <Route path="/delivery" element={<UserSeller infoSource={infoSource} capability="canAccessMyShop"><Delivery infoSource={infoSource} /></UserSeller>} />
                 <Route path="/postman" element={<UserSeller infoSource={infoSource} capability="canAccessMyShop"><Postman infoSource={infoSource} /></UserSeller>} />
                 <Route path="/dropshipping/*" element={<UserSeller infoSource={infoSource} capability="canAccessSellerCenter"><CJDropshippingDashboard infoSource={infoSource} /></UserSeller>} />
                 {/* Dropshipping Interne Elakay (Phase 4) -- catalogue Provider géré ici,
                     indépendant de CJDropshippingDashboard ci-dessus. Add/list restreints au
                     rôle Provider côté frontend (UserProvider) ET côté backend
                     (server_elakay/dropshippingInterne/middleware/permissions.js). */}
                 {/* Provider Center -- central Provider workspace, Provider storefront (My Shop) and its
                     Page Builder. Same UserProvider guard as every other /provider/* page. */}
                 <Route path="/provider" element={<UserProvider infoSource={infoSource}><ProviderCenter infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/my-shop" element={<UserProvider infoSource={infoSource}><ProviderMyShop infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/my-shop/builder" element={<UserProvider infoSource={infoSource}><ProviderStorefrontBuilder infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/products" element={<UserProvider infoSource={infoSource}><ProviderProducts infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/products/add" element={<UserProvider infoSource={infoSource}><ProviderAddProduct infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/products/:id/edit" element={<UserProvider infoSource={infoSource}><ProviderEditProduct infoSource={infoSource} /></UserProvider>} />
                 {/* Seller side (spec §26 route naming) -- gated by the existing UserSeller wrapper,
                     same double guard (frontend + backend requireSellerOwnerOrAdmin) as Provider above. */}
                 {/* Provider storefront website (published pages, B2B actions): Sellers + professional roles,
                     and the Provider itself for its own storefront. /seller/providers?providerId= stays the
                     full catalogue (search/filters) and keeps every old link working. */}
                 <Route path="/provider-shop/:providerId" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders" ownStorefront="render"><ProviderStorefrontPage infoSource={infoSource} /></ProviderStorefrontRoute>} />
                 <Route path="/provider-shop/:providerId/about" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders" ownStorefront="render"><ProviderStorefrontPage infoSource={infoSource} /></ProviderStorefrontRoute>} />
                 <Route path="/seller/providers" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders"><SellerProviderMarketplace infoSource={infoSource} /></ProviderStorefrontRoute>} />
                 <Route path="/seller/provider-products" element={<UserSeller infoSource={infoSource} capability="canImportProviderProduct"><SellerProviderProducts infoSource={infoSource} /></UserSeller>} />
                 {/* "View Product" -- real Provider Product detail/preview page, distinct from Add Product
                     (ticket §8). Always reloaded via GET from the URL id, never only location.state. */}
                 <Route path="/seller/provider-products/:providerProductId" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders"><ProviderProductDetail infoSource={infoSource} /></ProviderStorefrontRoute>} />
                 {/* Sell Center "Dropshipping In" card -- shares ProviderSectionHeader/ProviderProductCard
                     with /seller/providers above, different framing (spec §3/§12). */}
                 <Route path="/seller/provider-products/:providerProductId/buy" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders"><ProviderProductDetail infoSource={infoSource} /></ProviderStorefrontRoute>} />
                 {/* Seller Sourcing History (Seller features; the Royalty /user-viewed history is separate). */}
                 <Route path="/seller/provider-history/providers" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders"><ProviderHistoryPage infoSource={infoSource} /></ProviderStorefrontRoute>} />
                 <Route path="/seller/provider-history/products" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders"><ProviderProductHistoryPage infoSource={infoSource} /></ProviderStorefrontRoute>} />
                 <Route path="/seller/provider-catalog" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders"><ProviderCatalog infoSource={infoSource} mode="catalog" /></ProviderStorefrontRoute>} />
                 <Route path="/seller/provider-search" element={<ProviderStorefrontRoute infoSource={infoSource} capability="canBrowseProviders"><ProviderCatalog infoSource={infoSource} mode="search" /></ProviderStorefrontRoute>} />
                 <Route path="/seller/provider-orders" element={<UserSeller infoSource={infoSource} capability="canBrowseProviders"><OrdersPage infoSource={infoSource} side="seller" /></UserSeller>} />
                 <Route path="/seller/provider-inventory" element={<UserSeller infoSource={infoSource} capability="canBrowseProviders"><InventoryPage infoSource={infoSource} side="seller" /></UserSeller>} />
                 <Route path="/seller/provider-subscriptions" element={<UserSeller infoSource={infoSource} capability="canBrowseProviders"><SellerPASubscriptions infoSource={infoSource} /></UserSeller>} />
                 <Route path="/provider/orders" element={<UserProvider infoSource={infoSource}><OrdersPage infoSource={infoSource} side="provider" /></UserProvider>} />
                 <Route path="/provider/inventory" element={<UserProvider infoSource={infoSource}><InventoryPage infoSource={infoSource} side="provider" /></UserProvider>} />
                 <Route path="/provider/pa-plans" element={<UserProvider infoSource={infoSource}><ProviderPAPlans infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/subscriptions" element={<UserProvider infoSource={infoSource}><ProviderSubscribers infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/connected-sellers" element={<UserProvider infoSource={infoSource}><ConnectedSellers infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/trash" element={<UserProvider infoSource={infoSource}><ProviderTrash infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/connected-sellers/:sellerId" element={<UserProvider infoSource={infoSource}><ConnectedSellerProducts infoSource={infoSource} /></UserProvider>} />
                 <Route path="/provider/settings" element={<UserProvider infoSource={infoSource}><ProviderSettings infoSource={infoSource} /></UserProvider>} />
                 <Route path="/seller/dropshipping-in" element={<UserSeller infoSource={infoSource} capability="canBrowseProviders"><DropshippingIn infoSource={infoSource} /></UserSeller>} />
                 {/* "Add Product - Dropshipping In" -- Sell Your Product (addProduct.jsx) is the design
                     model; providerProductId is the ProviderProduct id, reloaded via GET so a direct
                     refresh always works (spec §2/§9/§28/§29 -- route corrected under /seller/provider-products
                     per this ticket's explicit route list). */}
                 <Route path="/seller/provider-products/add/:providerProductId" element={<UserSeller infoSource={infoSource} capability="canImportProviderProduct"><DropshippingInAddProduct infoSource={infoSource} /></UserSeller>} />

                {/* ______________Become a Associate Page_____________ */}
                <Route path="/user_Shoosing/:token" element={<UserChoosingEntry infoSource ={infoSource}  />} />
                 <Route path="/group-invitation/:publicId" element={<GroupInvitationPublic />} />
                 <Route path="/group-invitation/join/:publicId" element={<UserAssoociate><GroupInvitationJoin /></UserAssoociate>} />
                 <Route path="/admin_associat/group-invitations" element={<UserAssoociate><GroupInvitationsAdmin /></UserAssoociate>} />
                <Route path="/Add-u-all" element={<UserAssoociate ><AdminFamily infoSource ={infoSource}/></UserAssoociate>} />
                 {/* ------------Page for All Administrator And Family-------------------- */}

                 <Route path="/admin_associat" element={<UserAssoociate> <Admin_associate infoSource = {infoSource}/></UserAssoociate>}/>
                 <Route path="/elakay-language" element={<PageAccessRoute pageKey="family.language.editor" infoSource={infoSource} guard={UserFamily} hasRoleAccess={() => Family()}><AddLanguage infoSource ={infoSource}/></PageAccessRoute>} />
                 <Route path="/pageBuilder" element={<UserFamily ><DeferredRoute><PageBuilderIndex infoSource={infoSource} /></DeferredRoute></UserFamily>} />
                 <Route path="/elakay/investments-dashboard" element={<UserFamily ><InvestmentDashboard infoSource={infoSource} /></UserFamily>} />
                 <Route path="/elakay/job-dashboard" element={<UserFamily ><JobDashboard infoSource={infoSource} /></UserFamily>} />
                 <Route path="/elakay/job-positions" element={<PageAccessRoute pageKey="family.jobs.positions" infoSource={infoSource} guard={UserFamily} hasRoleAccess={() => Family()}><JobPositionsAdmin infoSource={infoSource} /></PageAccessRoute>} />
                 <Route path="/elakay/job-applications" element={<UserFamily ><JobApplicationsAdmin infoSource={infoSource} /></UserFamily>} />
                 <Route path="/elakay/how-we-do-it-dashboard" element={<PageAccessRoute pageKey="family.howWeDoIt.dashboard" infoSource={infoSource} guard={UserFamily} hasRoleAccess={() => Family()}><HowWeDoItDashboard infoSource={infoSource} /></PageAccessRoute>} />
                 <Route path="/elakay/how-we-do-it-editor" element={<PageAccessRoute pageKey="family.howWeDoIt.editor.new" infoSource={infoSource} guard={UserFamily} hasRoleAccess={() => Family()}><HowWeDoItEditor infoSource={infoSource} /></PageAccessRoute>} />
                 <Route path="/elakay/how-we-do-it-editor/:id" element={<PageAccessRoute pageKey="family.howWeDoIt.editor.edit" infoSource={infoSource} guard={UserFamily} hasRoleAccess={() => Family()}><HowWeDoItEditor infoSource={infoSource} /></PageAccessRoute>} />

                 
                  {/* <Route path="/elakay/Page_Settings" element={<UserFamily ><Page_APP infoSource ={infoSource} /></UserFamily>}/> */}
                   {/* <Route path="/elakay/investement" element={<UserFamily ><ProjectEditorExample infoSource ={infoSource} /></UserFamily>}/> */}
                 <Route path="/elakay/Settings" element={<UserFamily ><AnimationSettings infoSource ={infoSource} /></UserFamily>}/>
                 {/* Dynamic Swipers library -- Family only (UI gate here, 403 server-side for any other role). */}
                 {/* Family, or roles given swiper rights in Animation Settings -> Swiper Access & Limits. */}
                 <Route path="/elakay/swipers" element={<SwiperAccessRoute infoSource={infoSource}><SwiperManager infoSource ={infoSource} /></SwiperAccessRoute>}/>
                 <Route path="/elakay/swipers/studio" element={<SwiperAccessRoute infoSource={infoSource}><SwiperStudioPage infoSource={infoSource} /></SwiperAccessRoute>}/>
                 <Route path="/elakay/swipers/default-promo" element={<PageAccessRoute pageKey="family.swipers.defaultPromo" infoSource={infoSource} guard={UserFamily} hasRoleAccess={() => Family()}><DefaultPromoEditorPage infoSource={infoSource} /></PageAccessRoute>}/>
                 <Route path="/elakay/system-health" element={<UserFamily ><SystemHealthDashboard infoSource ={infoSource} /></UserFamily>}/>
                 {/* Transaction Center -- Family only (UI gate here; the API itself is auth + requireFamily, 403 for every other role). */}
                 <Route path="/elakay/transaction-center" element={<UserFamily ><TransactionCenter infoSource ={infoSource} /></UserFamily>}/>
                 {/* Manual Refund Center for roles Developer delegated "Scan Stripe" + "View scan results" to (the API re-checks every call). */}
                 <Route path="/elakay/transaction-center/refunds" element={<UserSignin><ManualRefundPage infoSource ={infoSource} /></UserSignin>}/>
                 <Route path="/elakay/security-center" element={<UserFamily ><SecurityCenter infoSource ={infoSource} /></UserFamily>}/>
                 {/* Elakay Permission Center -- owner only. The page itself is only behind UserSignin: the
                     server decides (owner ID allowlist + real Family role + no Switch Role + kill switch)
                     and the page shows an explicit refusal otherwise. Not delegable. */}
                 <Route path="/elakay/permission-center" element={<UserSignin><PermissionCenterPage infoSource ={infoSource} /></UserSignin>}/>
                 <Route path="/elakay/Settings/monitoring" element={<UserFamily ><MonitoringSettings infoSource ={infoSource} /></UserFamily>}/>
                 {/* Email Marketing (spec §3): minimum role is Seller, not Family --
                     server-side permission is still the real gate (assertEmailMarketingPermission),
                     UserSeller here is UI convenience only. Settings themselves stay Family-only. */}
                 <Route path="/elakay/email-marketing-dashboard" element={<UserSeller infoSource={infoSource} capability="canAccessMyShop"><EmailMarketingAccessRoute><DeferredRoute><EmailMarketingDashboard infoSource={infoSource} /></DeferredRoute></EmailMarketingAccessRoute></UserSeller>} />
                 <Route path="/elakay/email-marketing-editor/:id" element={<UserSeller infoSource={infoSource} capability="canAccessMyShop"><EmailMarketingAccessRoute><DeferredRoute><EmailMarketingEditor infoSource={infoSource} /></DeferredRoute></EmailMarketingAccessRoute></UserSeller>} />
                 <Route path="/elakay/Settings/email-marketing" element={<UserFamily ><EmailMarketingSettings infoSource ={infoSource} /></UserFamily>}/>
                 {/* Email Inbox (spec §16): personal to the signed-in account, any role
                     -- same UserSignin guard as /profile and /account, not role-gated
                     like Email Marketing itself (sending vs. receiving are different
                     permissions entirely). */}
                 <Route path="/email-inbox" element={<UserSignin><EmailInboxPage infoSource={infoSource} /></UserSignin>} />
                 {/* Direct email deep-link (spec §17): clean navigation, direct
                     refresh, browser back/forward, a shareable-within-the-account
                     URL. Same component/guard as the list route above. */}
                 <Route path="/email-inbox/:emailId" element={<UserSignin><EmailInboxPage infoSource={infoSource} /></UserSignin>} />
                 <Route path="/elakay/chatbot-dashboard" element={<PageAccessRoute pageKey="family.chatbot.dashboard" infoSource={infoSource} guard={UserFamily} hasRoleAccess={() => Family()}><ChatbotDashboard infoSource ={infoSource} /></PageAccessRoute>}/>
                 <Route path="/traductor-team" element={<UserFamily ><AddTraductorTeam infoSource ={infoSource} /></UserFamily>}/>
                 <Route path="/category" element={<UserFamily ><CreatCategory infoSource ={infoSource} /></UserFamily>}/>
                 <Route path="/filters" element={<UserFamily ><CreatFilters infoSource ={infoSource}/></UserFamily>}/>
                 <Route path="/filters/items/:filterID" element={<UserFamily ><CreatFiltersValue infoSource ={infoSource}/></UserFamily>} />
                 <Route path="/filter/:categoryId" element={<UserFamily ><CreatFilerCategory infoSource ={infoSource}/></UserFamily>} />
                 <Route path="/LinkCategory/:categoryId" element={<UserFamily ><LinkCatToCat infoSource ={infoSource}/></UserFamily>} />
                 <Route path="/filter/:categoryId/:filterId" element={<UserFamily ><CreatfilterValue infoSource ={infoSource}/></UserFamily>} />
              </Routes>
              </Suspense>
        </BrowserRouter>
        );
};

export default RoutesElakay;
